import { Component, Signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';
import { User } from '../../../models/user';
import { AppState } from '../../../store/app.states';
import { Store } from '@ngrx/store';
import { SignUp } from '../../../store/actions/auth.actions';
import { Observable } from 'rxjs';
import { seelectIsLoading, selectAuthErrorMessage } from '../../../store/selectors/auth.selectors';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';


@Component({
    selector: 'app-register',
    imports: [ButtonModule, CommonModule, CheckboxModule, InputTextModule, PasswordModule, FormsModule, RouterModule, RippleModule],
    templateUrl: './register.component.html',
    styleUrl: './register.component.scss'
})
export class RegisterComponent {

    errorMessage$: Observable<string | null>;
    confirmPassword: string = '';

    isLoading: Signal<boolean | undefined>;
    constructor(private store: Store<AppState>) {
        this.errorMessage$ = this.store.select(selectAuthErrorMessage);
        this.isLoading = toSignal(this.store.select(seelectIsLoading))

    }
    user: User = new User();
    onSubmit(): void {
        const email = this.user.email ?? '';
        const password = this.user.password ?? '';
        const firstName = this.user.firstName ?? '';
        const lastName = this.user.lastName ?? '';
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!firstName || !lastName || !email || !password) {
            this.formError = "Tous les champs sont obligatoires.";
            return;
        }
        if (!emailRegex.test(email)) {
            this.formError = 'Adresse e-mail invalide';
            return;
        }
        if (password !== this.confirmPassword) {
            this.formError = "Les mots de passe ne correspondent pas.";
            return;
        }

        if (password.length < 6) {
            this.formError = "Le mot de passe doit contenir au moins 6 caractères.";
            return;
        }
        this.store.dispatch(SignUp({ email, password, firstName, lastName }));

    }
    email: string = '';
    formError: string | null = null;

}